import { render } from "./BenefitC.vue?vue&type=template&id=6787f173&scoped=true"
import script from "./BenefitC.vue?vue&type=script&lang=js"
export * from "./BenefitC.vue?vue&type=script&lang=js"

import "./BenefitC.vue?vue&type=style&index=0&id=6787f173&scoped=true&lang=css"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6787f173"]])

export default __exports__